module.exports = __webpack_public_path__ + "static/img/city-mob-gold-ar-3.80046a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/city-mob-gold-ar-3.png
// module id = 1070
// module chunks = 173